interface PercentPieProps {
    percent: number;
    mode?: 'allocation' | 'payment';
    label?: string;
    size?: 'sm';
}

const RADIUS = 15.9155;
const CIRCUMFERENCE = 100;

const PercentPie = ({ percent, mode = 'allocation', label, size }: PercentPieProps) => {
    const raw = Number.isFinite(percent) ? percent : 0;
    const filled = Math.min(CIRCUMFERENCE, Math.max(0, raw));
    const over = raw > 100;
    const full = !over && filled >= 99.5;
    const colorClass = mode === 'payment'
        ? raw + 1e-7 >= 100 ? 'text-success' : raw > 50 ? 'text-warning' : 'text-danger'
        : over ? 'text-danger' : full ? 'text-success' : 'text-info';
    const defaultLabel = Number.isInteger(Math.round(raw * 10) / 10)
        ? `${Math.round(raw)}%`
        : `${(Math.round(raw * 10) / 10).toFixed(1)}%`;

    return (
        <div className="percent-pie-cell">
            <svg
                className={`percent-pie${size === 'sm' ? ' percent-pie--sm' : ''}`}
                viewBox="0 0 36 36"
                aria-hidden="true"
            >
                <circle
                    className="percent-pie__track"
                    cx="18"
                    cy="18"
                    r={RADIUS}
                />
                {filled > 0 ? (
                    <circle
                        className={`percent-pie__slice ${colorClass}`}
                        cx="18"
                        cy="18"
                        r={RADIUS}
                        strokeDasharray={`${filled} ${CIRCUMFERENCE - filled}`}
                        strokeDashoffset="25"
                        strokeLinecap={filled > 0 && filled < 100 ? 'round' : 'butt'}
                    />
                ) : null}
            </svg>
            <span className={`fs-12 ${mode === 'payment' ? colorClass : over ? 'text-danger' : 'text-muted'}`}>{label ?? defaultLabel}</span>
        </div>
    );
};

export default PercentPie;
